import { render } from "./VerbPractice.vue?vue&type=template&id=4b3f2e41&scoped=true"
import script from "./VerbPractice.vue?vue&type=script&lang=js"
export * from "./VerbPractice.vue?vue&type=script&lang=js"

import "./VerbPractice.vue?vue&type=style&index=0&id=4b3f2e41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3f2e41"]])

export default __exports__